module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8615/img/website-performance-rating.jpg"